import React from 'react';
import logo from './logo.svg';
import './App.css';
import HamburgerMenu from './Components/HamburgerMenu';
import { BrowserRouter , Routes,  Route, Link } from "react-router-dom";
import Page_Index from './Components/Page_Index';
import Page_Edit from './Components/Page_Edit';

import Footer from './Components/Footer';


function App() {
  return (
    <div className="container mx-20">
       <div className="">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Page_Index/>}></Route>
            <Route path="/Add" element={<Page_Edit/>}></Route>
            <Route path="/Edit/:id" element={<Page_Edit/>}></Route>
            <Route path="/*" element={<>404 Not found</>}></Route>
          </Routes>
        </BrowserRouter>
    </div>
    <Footer/>
    </div>
  );
}

export default App;
